import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayerListEffectModule } from '../layer-list-effect/layer-list-effect.module';
import { HeatmapLayersComponent } from './heatmap-layers.component';

@NgModule({
  imports: [CommonModule, LayerListEffectModule],
  declarations: [HeatmapLayersComponent],
  exports: [HeatmapLayersComponent],
})
export class HeatmapLayersModule {}
